import React, { useState, useEffect } from "react";
import Ratings from "./Ratings";
import RatingTemp from "./RatingTemp";
import Pagination from "./Pagination";
import { AiFillStar } from "react-icons/ai";
import RatingReact from "react-rating";
import { CiStar } from "react-icons/ci";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  customer_review,
  messageClear,
  get_reviews,
  get_product,
} from "../store/reducers/homeReducer";
import toast from "react-hot-toast";

const Reviews = ({ productId, product, sellerId }) => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { successMessage, reviews, totalReview, rating_review } = useSelector(
    (state) => state.home
  );
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const [rat, setRat] = useState("");
  const [re, setRe] = useState("");
  const [guestName, setGuestName] = useState("");

  const review_submit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!rat) {
      toast.error("Please select a rating");
      return;
    }
    if (!re.trim()) {
      toast.error("Please write a review");
      return;
    }
    
    // Use guest name if no user info, otherwise use user name
    const reviewerName = userInfo ? userInfo.name : guestName.trim();
    
    if (!reviewerName) {
      toast.error("Please enter your name");
      return;
    }

    const obj = {
      name: reviewerName,
      review: re,
      rating: rat,
      productId: productId || product?._id,
    };
    dispatch(customer_review(obj));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(
        get_reviews({
          productId: productId || product?._id,
          pageNumber,
        })
      );
      if (product?.slug && sellerId) {
        dispatch(get_product({ sellerId, slug: product.slug }));
      }
      setRat("");
      setRe("");
      setGuestName("");
      dispatch(messageClear());
    }
  }, [successMessage]);

  useEffect(() => {
    const id = productId || product?._id;
    if (id) {
      dispatch(
        get_reviews({
          productId: id,
          pageNumber,
        })
      );
    }
  }, [pageNumber, productId, product]);

  if (!productId && !product?._id) {
    return null;
  }

  return (
    <div className="mt-8">
      {/* Rating Overview */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-8">
      <div className="flex gap-10 md:flex-col">
          <div className="flex flex-col gap-2 justify-start items-start">
            <div className="flex items-baseline gap-2">
              <span className="text-5xl font-bold text-gray-800">{product?.rating || 0}</span>
              <span className="text-xl text-gray-500">/5</span>
            </div>
            <div className="flex text-2xl mb-2">
              <Ratings ratings={product?.rating || 0} />
            </div>
            <p className="text-sm text-gray-500">{totalReview} Customer Reviews</p>
          </div>

          {/* Rating Distribution */}
          <div className="flex-1">
            <div className="space-y-4">
              {[5, 4, 3, 2, 1].map((rating) => (
                <div key={rating} className="flex items-center gap-4">
                  <div className="flex items-center gap-1 w-24">
                    <span className="text-sm font-medium text-gray-600">{rating}</span>
                    <span className="text-yellow-400">★</span>
            </div>
                  <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                      className="h-full bg-yellow-400 rounded-full transition-all duration-300"
                style={{
                  width: `${Math.floor(
                          (100 * (rating_review[5 - rating]?.sum || 0)) / (totalReview || 1)
                  )}%`,
                }}
                    />
            </div>
                  <span className="text-sm text-gray-500 w-12 text-right">
                    {rating_review[5 - rating]?.sum || 0}
                  </span>
          </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Review Form */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-8">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Write a Review</h3>
        <form onSubmit={review_submit} className="space-y-4">
          {/* Name field - only show for guest users */}
          {!userInfo && (
            <div>
              <label htmlFor="guestName" className="block text-sm font-medium text-gray-700 mb-2">
                Your Name *
              </label>
              <input
                type="text"
                id="guestName"
                value={guestName}
                onChange={(e) => setGuestName(e.target.value)}
                placeholder="Enter your name"
                className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all duration-200"
                required
              />
            </div>
          )}
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Rating *
            </label>
            <div className="flex gap-1">
              <RatingReact
                onChange={(e) => setRat(e)}
                initialRating={rat}
                emptySymbol={
                  <span className="text-gray-300 text-3xl hover:text-yellow-400 transition-colors">
                    <CiStar />
                  </span>
                }
                fullSymbol={
                  <span className="text-yellow-400 text-3xl">
                    <AiFillStar />
                  </span>
                }
              />
            </div>
          </div>
          
          <div>
            <label htmlFor="review" className="block text-sm font-medium text-gray-700 mb-2">
              Review *
            </label>
            <textarea
              id="review"
              value={re}
              required
              onChange={(e) => setRe(e.target.value)}
              placeholder="Share your experience with this product..."
              className="w-full p-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all duration-200"
              rows="4"
            />
          </div>
          
          <button
            type="submit"
            className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-200 font-medium"
          >
            Submit Review
          </button>
        </form>
      </div>

      {/* Reviews List */}
      <div className="space-y-6">
        <h2 className="text-xl font-semibold text-gray-800">
          Customer Reviews ({totalReview})
        </h2>
        
        {reviews.length > 0 ? (
          <div className="space-y-6">
            {reviews.map((r, i) => (
              <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h4 className="font-medium text-gray-800 mb-1">{r.name}</h4>
                    <div className="flex gap-1 text-lg">
                      <RatingTemp rating={r.rating} />
                    </div>
                  </div>
                  <span className="text-sm text-gray-500">{r.date}</span>
                </div>
                <p className="text-gray-600 leading-relaxed">{r.review}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
            <p className="text-gray-500">No reviews yet. Be the first to review this product!</p>
          </div>
        )}

        {/* Pagination */}
        {totalReview > 5 && (
          <div className="flex justify-end mt-6">
            <Pagination
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalItem={totalReview}
              perPage={perPage}
              showItem={Math.round(totalReview / 5)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Reviews;
